import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { RUN_STATUS } from "@/profitability/constants";
import type { EnrichedProfitabilityRun } from "@/profitability/types";
export const RunHeadline = ({ run }: { run: EnrichedProfitabilityRun }) => {
  // Guarded like the list's Result column. A run that failed after computing a
  // summary would otherwise show figures directly above "could not be built".
  if (run.status !== RUN_STATUS.completed || !run.display.summary.length)
    return null;
  return (
    <Stack direction="row" align="baseline" gap="lg" className="flex-wrap">
      {run.display.summary.map((figure) => (
        <Stack key={figure.key} gap="none">
          <Typography variant="subtitleW2">{figure.displayValue}</Typography>
          <Typography variant="captionW1" textColor="tertiary">
            {figure.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
